import { ArchetypeDefinition } from '../../archetypeTypes';

export const MAGIC_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'magician',
        name: 'Magician',
        description: 'Pattern transformation and emergence across scales.',
        category: 'Magic',
        tags: ['transformation', 'emergence', 'nonlinearity'],
        weights: { fractalDimension: 0.4, waveIntensity: 0.2, linguisticComplexity: 0.2, energyLevel: 0.2 }
    },
    {
        key: 'alchemist',
        name: 'Alchemist',
        description: 'Catalytic conversions that increase order through change.',
        category: 'Magic',
        tags: ['catalysis', 'conversion', 'integration'],
        weights: { fractalDimension: 0.35, stability: 0.25, energyLevel: 0.2, edgeCount: 0.2 }
    }
];


